import type { PartialWidgetContext } from '@/types/cms'
import Partials from '@/elements/Partials'
import styles from './GridArticle.module.scss'
import AppContext from '@/types/context'
import { clsx } from 'clsx'

export interface GroupGridProps {
  children: Array<PartialWidgetContext>
}

const GridArticle = ({ item, context }: { item: GroupGridProps; context: AppContext }) => {
  return (
    <div className={clsx(styles.article, 'article-content')}>
      {item.children.map((widget: PartialWidgetContext, index) => {
        return <Partials key={index} item={widget as any} context={context} />
      })}
    </div>
  )
}

export default GridArticle
